import React from "react";
import { Link } from "@mui/material";

interface CellProps {
  renderedCellValue: React.ReactNode;
  row: {
    original: {
      orderNumber: string;
    };
  };
}
const momentumUrl = import.meta.env.VITE_MOMENTUM_URL;
export const OrderNumberCell = ({ renderedCellValue, row }: CellProps) => (
  <Link href={`${momentumUrl}new-home/${row.original.orderNumber}`} target="_blank">
    {renderedCellValue}
  </Link>
);
